import React, { useState } from "react";
import "./PostQuantum.css";
import { MdSecurity } from "react-icons/md";
import { GiFeather, GiTreeBranch } from "react-icons/gi";
import { FaLock, FaKey } from "react-icons/fa";

const PostQuantumPage = () => {
  const [hybridMode, setHybridMode] = useState(true);
  const [fallbackMode, setFallbackMode] = useState(false);

  return (
    <div className="pqc-page">
      <div className="pqc-grid">
        {/* Left Card */}
        <div className="card pqc-config">
          <h2>PQC Configuration</h2>

          <div className="setting-row">
            <div>
              <label>Default Signature Algorithm</label>
              <p>Choose the default algorithm for digital signatures.</p>
            </div>

            <select>
              <option>Dilithium3 (Recommended)</option>
              <option>Falcon-512</option>
              <option>SPHINCS+</option>
            </select>
          </div>

          <div className="setting-row">
            <div>
              <label>Hybrid Mode</label>
              <p>
                Use hybrid (PQC + Classical) signatures for maximum
                compatibility.
              </p>
            </div>

            <label className="switch">
              <input
                type="checkbox"
                checked={hybridMode}
                onChange={() => setHybridMode(!hybridMode)}
              />
              <span className="slider"></span>
            </label>
          </div>

          <div className="setting-row">
            <div>
              <label>PQC Security Level</label>
              <p>Select the security level for PQC algorithms.</p>
            </div>

            <select>
              <option>Level 3 (128-bit)</option>
              <option>Level 5 (256-bit)</option>
            </select>
          </div>

          <div className="setting-row">
            <div>
              <label>Fallback to Classical</label>
              <p>
                Allow fallback to classical algorithms if PQC is not supported.
              </p>
            </div>

            <label className="switch">
              <input
                type="checkbox"
                checked={fallbackMode}
                onChange={() => setFallbackMode(!fallbackMode)}
              />
              <span className="slider"></span>
            </label>
          </div>

          <div className="setting-row">
            <div>
              <label>Provider</label>
              <p>Select cryptographic provider.</p>
            </div>

            <select>
              <option>Entrust PQC Library v2.1.0</option>
              <option>Open Quantum Safe</option>
              <option>Bouncy Castle PQC</option>
            </select>
          </div>
        </div>

        {/* Right Column */}
        <div className="right-column">
          {/* Algorithm Status */}
          <div className="card">
            <h2>PQC Algorithm Status</h2>

            <div className="algo-row">
              <span className="algo-name"><MdSecurity className="algo-icon icon-red" />Dilithium3</span>
              <span className="enabled">Enabled</span>
              <div className="algo-badges">
                <span className="default-badge">Default</span>
              </div>
            </div>

            <div className="algo-row">
              <span className="algo-name"><GiFeather className="algo-icon icon-red" />Falcon-512</span>
              <span className="enabled">Enabled</span>
              <span />
            </div>

            <div className="algo-row">
              <span className="algo-name"><GiTreeBranch className="algo-icon icon-yellow" />SPHINCS+</span>
              <span className="enabled">Enabled</span>
              <span />
            </div>

            <div className="algo-row">
              <span className="algo-name"><FaLock className="algo-icon icon-blue" />Kyber768</span>
              <span className="enabled">Enabled</span>
              <span />
            </div>

            <div className="algo-row">
              <span className="algo-name"><FaKey className="algo-icon icon-blue" />Classic (ECDSA)</span>
              <span className="enabled">Enabled</span>
              <div className="algo-badges">
                <span className="fallback-badge">Fallback</span>
              </div>
            </div>
          </div>

          {/* Adoption */}
          <div className="card">
            <h2>PQC Adoption</h2>

            <div className="adoption-wrapper">
              <div className="donut-chart">
                <div className="donut-center">
                  <h2>68%</h2>
                </div>
              </div>

              <div className="legend">
                <div>
                  <span className="dot purple"></span>
                  PQC Signatures <strong>68%</strong>
                </div>

                <div>
                  <span className="dot blue"></span>
                  Hybrid Signatures <strong>24%</strong>
                </div>

                <div>
                  <span className="dot gray"></span>
                  Classical Signatures <strong>8%</strong>
                </div>
              </div>
            </div>

            <p className="chart-note">Based on last 30 days</p>
          </div>
        </div>
      </div>

      {/* Bottom Card */}
      <div className="card about-card">
        <h2>About Post-Quantum Cryptography</h2>

        <p>
          PQC algorithms are designed to resist attacks from quantum computers
          and ensure long-term security of your digital assets.
        </p>

        <a href="/">Learn more about PQC →</a>
      </div>
    </div>
  );
};

export default PostQuantumPage;